import React, {useState} from 'react';
import {useEffect} from 'react';
import env from '../../../util/env';
import {useSelector, useDispatch} from 'react-redux';
import Table from '@ey/motif-react-wrapper/Table';
import MotifTableHeaderRenderer from '@ey/motif-react-wrapper/TableHeaderRenderer';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';
import Loader from '../../Common/Loaders/loadingindicator';
import {
	labels,
	toastDuration,
	workspaceCreationStatus,
	toastVariants
} from '../../../util/uiconstants';
import AccessDeniedMessage from '../../Common/AccessDeniedMessage/AccessDeniedMessage';
import Wrapper from './Styles/sharepointWorkspacesbasestyle';
import {clearErrors} from '../../../actions/erroractions';
import {setIsModalOpen} from '../../../actions/modalstateactions';
import {getAllActiveDataCenters} from '../../../actions/admin/sharepointworkspacesactions';
import WorkspacesWrapper from './WorkspaceDrawer/workspaceswrapper';
import FormField from '@ey/motif-react-wrapper/FormField';
import Search from '@ey/motif-react-wrapper/Search';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import AddWorkspaceModal from './addworkspacemodal';
import Toast from '../../Common/Toast/Toast';
import {compareNumericStrings, getLocalizedAPIError} from '../common/util';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';

function DataCenterDetails() {
	const dataCentersSharepointWorkspaces = useSelector(
		(store) => store.dataCentersSharepointWorkspaces
	);
	const userPermissions = useSelector((store) => store.userPermissions);
	const defaultToastMessage = {toastVariant: '', message: ''};

	const [loading, setLoading] = useState(false);
	const [showDrawer, setshowDrawer] = useState(false);
	const [currentDatacenter, setCurrentDatacenter] = useState({});
	const [searchInputValue, setSearchInputValue] = useState('');
	const [showWorkspaceModal, setShowWorkspaceModal] = useState(false);
	const [toastMessage, setToastMessage] = useState(defaultToastMessage);
	const [dataCenterTableRowData, setDataCenterTableRowData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		setDataCenterTableRowData(dataCentersSharepointWorkspaces);
	}, [dataCentersSharepointWorkspaces]);

	useEffect(() => {
		if (toastMessage.toastVariant === toastVariants.success) {
			let timer = setTimeout(() => {
				setToastMessage(defaultToastMessage);
			}, toastDuration);

			return () => clearTimeout(timer);
		}
	}, [toastMessage.message]);

	useEffect(() => {
		clearError(true);
		loadDatacenters();
	}, []);

	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	const columnDefs = [
		{
			minWidth: 350,
			width: 350,
			flex: 4,
			headerName: labels.dataCenterNameHeader,
			field: 'dataCenterName',
			sort: 'asc',
			cellRenderer: (params) => dataCenterNameNameCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.dataCenterNameHeader,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			}
		},
		{
			minWidth: 350,
			width: 350,
			flex: 4,
			headerName: labels.numberOfWorkSpacesHeader,
			field: 'workspacesCount',
			cellRenderer: (params) =>
				numberofWorkspacesDecriptionCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.numberOfWorkSpacesHeader,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			},
			comparator: compareNumericStrings
		},
		{
			minWidth: 350,
			width: 350,
			flex: 4,
			headerName: labels.pendingWorkSpacesHeader,
			field: 'pendingWorkspacesCount',
			cellRenderer: (params) => pendingWorkspacesCountCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.pendingWorkSpacesHeader,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			},
			comparator: compareNumericStrings
		}
	];

	const dataCenterNameNameCellRenderer = (e) => {
		return (
			<>
				<section className="roleType motif-body2-default-light">
					<section>
						<a
							onClick={() => {
								onDatacenterClick(e.data);
							}}
							className="groupname"
						>
							{ellipsesControlRender(e.data.dataCenterName)}
						</a>
					</section>
				</section>
			</>
		);
	};

	const numberofWorkspacesDecriptionCellRenderer = (e) => {
		return (
			<section className="roleType motif-body2-default-light">
				{e?.data?.workspacesCount}
			</section>
		);
	};

	const pendingWorkspacesCountCellRenderer = (e) => {
		return (
			<section className="roleType motif-body2-default-light">
				{e?.data?.pendingWorkspacesCount}
			</section>
		);
	};

	const ellipsesControlRender = (text) => {
		return (
			<section className="roleType">
				<EllipsesControl
					content={text}
					tooltip={text}
					noOfLines={1}
					ellipsisClass="columnName"
				/>
			</section>
		);
	};

	const onDatacenterClick = (data) => {
		setshowDrawer(true);
		setCurrentDatacenter(data);
	};

	const closeDrawer = () => {
		setshowDrawer(false);
		setCurrentDatacenter({});
	};

	const loadDatacenters = (showLoading = true) => {
		setLoading(showLoading);

		let url =
			env.getURL('serviceUrlV2') +
			`admin/datacenters?includeCollaborationWorkspaces=true`;
		dispatch(getAllActiveDataCenters(url))
			.then(() => {})
			.catch((error) => {
				setToastMessage({
					toastVariant: toastVariants.error,
					message: getLocalizedAPIError(error)
				});
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const onSearchChange = () => {
		let filteredData = dataCentersSharepointWorkspaces
			.filter(
				(ee) =>
					ee.dataCenterName
						?.toLowerCase()
						.includes(searchInputValue.trim().toLowerCase()) ||
					ee.workspacesCount
						?.toString()
						.includes(searchInputValue.trim().toLowerCase()) ||
					ee.pendingWorkspacesCount
						?.toString()
						.includes(searchInputValue.trim().toLowerCase())
			)
			.map((dd) => dd);

		setDataCenterTableRowData(filteredData);
	};

	const onClearSearchClick = () => {
		setSearchInputValue('');
		setDataCenterTableRowData(dataCentersSharepointWorkspaces);
	};

	const hasPermissions = () => {
		const sharepointWorkSpacesPermission = userPermissions?.permissions;

		return (
			sharepointWorkSpacesPermission?.canReadCollaborationSites ||
			sharepointWorkSpacesPermission?.canCreateUpdateCollaborationSites ||
			sharepointWorkSpacesPermission?.canDeleteCollaborationSites
		);
	};

	const getRowStyle = (params) => {
		if (params.node.rowIndex % 2 === 0) {
			return {background: 'var(--neutrals-00white)'};
		} else {
			return {background: 'var(--ui-background-secondary)'};
		}
	};

	const onAddWorkspaceModalClose = (statusObject) => {
		const {statusId} = statusObject;

		setShowWorkspaceModal(false);
		if (statusId === workspaceCreationStatus.Success) {
			setToastMessage({
				toastVariant: toastVariants.success,
				message: labels.workspaceAddedSuccess
			});
		} else if (statusId === workspaceCreationStatus.Failed) {
			setToastMessage({
				toastVariant: toastVariants.error,
				message: labels.workspaceAddedFailed
			});
		}
		loadDatacenters(false);
	};

	const noRowsOverlayComponentParams = () => {
		return <section className="norecord">{labels.noResultsFound}</section>;
	};

	const hasCreateUpdatePermission = () => {
		return userPermissions?.permissions?.canCreateUpdateCollaborationSites;
	};

	return (
		<Wrapper>
			{hasPermissions() ? (
				<section className="mainwrapper">
					{toastMessage.message.length > 0 && (
						<section>
							<Toast
								position="top"
								variant={toastMessage.toastVariant}
								onClose={() => {
									setToastMessage(defaultToastMessage);
								}}
							>
								{toastMessage.message}
							</Toast>
						</section>
					)}
					<section className="sharepointWorkspace mainResponsiveWrapper">
						<section className="add-on">
							<section className="search">
								<FormField>
									<Search
										placeholder={labels.searchUserText}
										value={searchInputValue}
										onChange={(e) => setSearchInputValue(e.target.value ?? '')}
										onSearchButtonClick={onSearchChange}
										onClear={onClearSearchClick}
										onEnter={onSearchChange}
										clearHoverText={labels.clear}
									/>
								</FormField>
							</section>
							<section className="add-workspace-section">
								<MotifTooltip
									id={'deletebButtonTooltipId'}
									hideCloseButton
									placement="left"
									flip={false}
									contentClassName="deleteicon"
									hide={hasCreateUpdatePermission() ? true : false}
									trigger={
										<section>
											<MotifButton
												className="add-workspace"
												variant="text-alt"
												size="medium"
												onClick={() => {
													setShowWorkspaceModal(true);
												}}
												disabled={hasCreateUpdatePermission() ? false : true}
											>
												<MotifIcon
													className="icon-container"
													iconFunction={IconoirPlusCircle}
													size="20"
												/>
												{labels.addWorkspace}
											</MotifButton>
										</section>
									}
								>
									{labels.insufficientPermission}
								</MotifTooltip>
							</section>
						</section>
					</section>

					{loading ? (
						<Loader variant={'circular'} />
					) : (
						<section className="sharepointWorkspaceTable mainResponsiveWrapper">
							<Table
								defaultColDef={{
									flex: 1,
									sortable: true,
									filter: false,
									resizable: false,
									minWidth: 180,
									lockPosition: true
								}}
								components={{agColumnHeader: MotifTableHeaderRenderer}}
								onGridReady={(params) => {
									params.api.sizeColumnsToFit();
								}}
								getRowStyle={getRowStyle}
								rowHeight={32}
								headerHeight={32}
								enableCellTextSelection={true}
								columnDefs={columnDefs}
								rowData={dataCenterTableRowData}
								noRowsOverlayComponent={noRowsOverlayComponentParams}
								rowBuffer={20}
							/>
						</section>
					)}
					{currentDatacenter.dataCenterId && (
						<section>
							<WorkspacesWrapper
								show={showDrawer}
								onClose={closeDrawer}
								currentDatacenter={currentDatacenter}
								setCurrentDatacenter={setCurrentDatacenter}
								dataCenterList={dataCenterTableRowData}
								loadDatacenters={loadDatacenters}
								userPermissions={userPermissions}
							/>
						</section>
					)}
					<section>
						{showWorkspaceModal && (
							<AddWorkspaceModal
								showModal={showWorkspaceModal}
								onClose={onAddWorkspaceModalClose}
							/>
						)}
					</section>
				</section>
			) : (
				<section className="message">
					<AccessDeniedMessage
						permissionMesage={labels.insufficientPermission}
					/>
				</section>
			)}
		</Wrapper>
	);
}

export default DataCenterDetails;
